import { axios } from '@/_metronic/helpers/network/Axios'
import { AxiosResponse } from 'axios'
import { DashboardActiveEmployee, DashboardAttendanceLog, DashboardAverageAge, DashboardContractCurrentMonth, DashboardContractType, DashboardGender, DashboardJobTitle, DashboardWorkTenure } from './_models'
import { BaseResponse } from '@/_metronic/helpers/crud-helper/base-list-response'

const HR_API_URL = '/hr-services'
const GET_REPORT_DASHBOARD_HR_LIST = '/employee/dashboard'

const getReportAverageAge = (body: any) =>
  axios
    .post(`${HR_API_URL}${GET_REPORT_DASHBOARD_HR_LIST}/age`, body)
    .then((d: AxiosResponse<BaseResponse<DashboardAverageAge[]>>) => d.data)

const getReportActiveEmployee = (body: any) =>
  axios
    .post(`${HR_API_URL}${GET_REPORT_DASHBOARD_HR_LIST}/active-employee`, body)
    .then((d: AxiosResponse<BaseResponse<DashboardActiveEmployee[]>>) => d.data)

const getReportGender = (body: any) =>
  axios
    .post(`${HR_API_URL}${GET_REPORT_DASHBOARD_HR_LIST}/gender`, body)
    .then((d: AxiosResponse<BaseResponse<DashboardGender[]>>) => d.data)

const getReportWorkTenure = (body: any) =>
  axios
    .post(`${HR_API_URL}${GET_REPORT_DASHBOARD_HR_LIST}/work-tenure`, body)
    .then((d: AxiosResponse<BaseResponse<DashboardWorkTenure[]>>) => d.data)

const getReportContractExpiredCurrentMonth = (body: any) =>
  axios
    .post(`${HR_API_URL}${GET_REPORT_DASHBOARD_HR_LIST}/contract-expired`, body)
    .then((d: AxiosResponse<BaseResponse<DashboardContractCurrentMonth[]>>) => d.data)

const getReportAttendanceLog = (body: any) =>
  axios
    .post(`${HR_API_URL}${GET_REPORT_DASHBOARD_HR_LIST}/attendance-log`, body)
    .then((d: AxiosResponse<BaseResponse<DashboardAttendanceLog[]>>) => d.data)

const getJobTitle = (body: any) =>
  axios
    .post(`${HR_API_URL}${GET_REPORT_DASHBOARD_HR_LIST}/job-title`, body)
    .then((d: AxiosResponse<BaseResponse<DashboardJobTitle[]>>) => d.data)

const getContractType = (body: any) =>
  axios
    .post(`${HR_API_URL}${GET_REPORT_DASHBOARD_HR_LIST}/contract-type`, body)
    .then((d: AxiosResponse<BaseResponse<DashboardContractType[]>>) => d.data)

export {
  getReportAverageAge,
  getReportActiveEmployee,
  getReportGender,
  getReportWorkTenure,
  getReportContractExpiredCurrentMonth,
  getReportAttendanceLog,
  getJobTitle,
  getContractType,
}
